import React from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import curatareMochete1 from "assets/images/DSC09845.webp";
import curatareMochete2 from "assets/images/DSC09870.webp";
import curatareMocheteSpecific from "assets/images/servicii/curatareMocheteSpecific.jpg";
import curatareMocheteChecklist from "assets/images/servicii/curatareMocheteChecklist.jpg";
import curatareMochete4 from "assets/images/DSC09835.webp";

function ArticleContent() {
    return (
        <MKBox component="section" py={4} mb={8}>
            <Container>
                <Grid container spacing={3} justifyContent="center">
                    <Grid item xs={12} lg={10}>
                        {/* H1 */}
                        <MKTypography variant="h1" component="h2" mb={3} color="dark">
                            Curățare profesională mochete și suprafețe textile
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Curăţarea mochetei în regim profesional reprezintă un întreg proces
                            tehnologic, realizat doar cu personal experimentat și echipamente
                            specializate.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Această intervenție tehnică îndepărtează eficient murdăria, praful și
                            petele, fără a afecta structura fibrei, asigurând un mediu sănătos în
                            spațiile interioare.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={4}>
                            La Doral Cleaning, ne focalizăm pe eliminarea bacteriilor și a
                            impurităților care se acumulează adânc în țesătură, asigurând o igienă
                            reală a mochetei, nu doar un aspect vizibil mai curat.
                        </MKTypography>

                        <MKBox
                            component="img"
                            src={curatareMochete1}
                            alt="Curățare profesională mochete și suprafețe textile"
                            width="100%"
                            borderRadius="xl"
                            shadow="md"
                            mb={4}
                        />

                        {/* H2 */}
                        <MKTypography variant="h2" mb={3} color="dark">
                            De ce trebuie să igienizezi periodic mocheta
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            O întreținere constantă a mochetei ajută la prelungirea duratei de viață
                            a materialelor textile prin eliminarea particulelor abrazive.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Praful și nisipul pătrund la baza firelor și funcționează ca niște lame
                            minuscule sub presiunea pașilor, distrugând materialul în timp.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Dincolo de protecția mecanică a fibrei, curățarea profundă joacă un rol
                            major în prevenirea și ameliorarea efectelor asupra persoanelor care
                            suferă de afecțiuni alergice, prin eliminarea factorilor declanșatori
                            precum acarienii sau polenul acumulat în țesătură.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={4}>
                            Igienizarea periodică restabilește textura originală și previne uzura
                            prematură, menținând un aspect proaspăt și un mediu de lucru cu adevărat
                            sănătos.
                        </MKTypography>

                        <MKBox
                            component="img"
                            src={curatareMochete2}
                            alt="Procesul de curățare mochete prin tratarea petelor dificile"
                            width="100%"
                            borderRadius="xl"
                            shadow="md"
                            mb={4}
                        />

                        {/* H2 */}
                        <MKTypography variant="h2" mb={3} color="dark">
                            Alegerea metodei de curatare potrivite pentru mocheta firmei
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={4}>
                            Pentru a înțelege rapid ce tip de intervenție este necesară pentru
                            pardoseala dumneavoastră, am sintetizat principalele metode de lucru
                            utilizate de echipa noastră:
                        </MKTypography>

                        <div
                            style={{
                                width: "100%",
                                overflowX: "auto",
                                WebkitOverflowScrolling: "touch",
                                marginBottom: "2rem",
                            }}
                        >
                            <table
                                style={{
                                    width: "100%",
                                    borderCollapse: "collapse",
                                    border: "1px solid #ddd",
                                    minWidth: "520px",
                                }}
                            >
                                <thead>
                                    <tr style={{ backgroundColor: "#f2f2f2" }}>
                                        <th
                                            style={{
                                                padding: "12px",
                                                border: "1px solid #ddd",
                                                textAlign: "left",
                                            }}
                                        >
                                            Metodă de lucru
                                        </th>
                                        <th
                                            style={{
                                                padding: "12px",
                                                border: "1px solid #ddd",
                                                textAlign: "left",
                                            }}
                                        >
                                            Tip de material recomandat
                                        </th>
                                        <th
                                            style={{
                                                padding: "12px",
                                                border: "1px solid #ddd",
                                                textAlign: "left",
                                            }}
                                        >
                                            Timp de uscare estimat
                                        </th>
                                        <th
                                            style={{
                                                padding: "12px",
                                                border: "1px solid #ddd",
                                                textAlign: "left",
                                            }}
                                        >
                                            Rezultat tehnic principal
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{ padding: "12px", border: "1px solid #ddd" }}>
                                            <strong>Injecție-Extracție</strong>
                                        </td>
                                        <td style={{ padding: "12px", border: "1px solid #ddd" }}>
                                            Fibre sintetice, mochete birou
                                        </td>
                                        <td style={{ padding: "12px", border: "1px solid #ddd" }}>
                                            4 - 6 ore
                                        </td>
                                        <td style={{ padding: "12px", border: "1px solid #ddd" }}>
                                            Eliminarea mizeriei până la baza suportului
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: "12px", border: "1px solid #ddd" }}>
                                            <strong>Curățare Uscată</strong>
                                        </td>
                                        <td style={{ padding: "12px", border: "1px solid #ddd" }}>
                                            Fibre naturale, textile delicate
                                        </td>
                                        <td style={{ padding: "12px", border: "1px solid #ddd" }}>
                                            Imediat / 1 oră
                                        </td>
                                        <td style={{ padding: "12px", border: "1px solid #ddd" }}>
                                            Protejarea texturii fără risc de intrare la apă
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: "12px", border: "1px solid #ddd" }}>
                                            <strong>Abur și Extracție</strong>
                                        </td>
                                        <td style={{ padding: "12px", border: "1px solid #ddd" }}>
                                            Orice material rezistent termic
                                        </td>
                                        <td style={{ padding: "12px", border: "1px solid #ddd" }}>
                                            2 - 4 ore
                                        </td>
                                        <td style={{ padding: "12px", border: "1px solid #ddd" }}>
                                            Decontaminare termică și distrugerea bacteriilor
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        {/* H2 */}
                        <MKTypography variant="h2" mb={3} color="dark">
                            Metoda de lucru și tehnologii utilizate
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Tehnologia modernă influențează direct calitatea rezultatului final și
                            eficiența procesului de igienizare.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            La Doral Cleaning, utilizăm o flotă de utilaje profesionale care ne
                            permit să adaptăm intensitatea curățării în funcție de gradul de
                            murdărie și de rezistența fibrei.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={4}>
                            Controlul precis al presiunii și al temperaturii apei asigură o curățare
                            uniformă, fără a risca deteriorarea suportului textil sau a adezivilor
                            folosiți în montaj.
                        </MKTypography>

                        {/* H2 */}
                        <MKTypography variant="h2" mb={3} color="dark">
                            Specificul materialelor și influența asupra metodei de igienizare
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Atât întreținerea, cât și curățarea unei suprafețe textile se realizează
                            în funcție de specificul materialului, legat de stratul suport și
                            compoziția materialelor în formarea țesăturii. Fiecare material oferă
                            proprietăți diferite de durabilitate, textură și rezistență la pete.
                            Analiza prealabilă ne permite să alegem metoda optimă de lucru pentru a
                            proteja materialul.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Materiale comune care stau la baza țesăturii:
                        </MKTypography>

                        <MKBox component="ul" pl={4} mb={4}>
                            <MKTypography component="li" variant="body1" color="text" mb={1}>
                                <strong>Fibre naturale</strong>: Lână, mătase, bumbac, iută, sisal,
                                cocos, lână de bambus.
                            </MKTypography>
                            <MKTypography component="li" variant="body1" color="text" mb={1}>
                                <strong>Fibre sintetice</strong>: Poliamidă (nylon), polipropilenă
                                (olefină), poliester (PET), poliacrilul, PVC.
                            </MKTypography>
                        </MKBox>

                        <MKBox
                            component="img"
                            src={curatareMocheteSpecific}
                            alt="Specificul materialelor - țesături diverse de mocheta si curatarea lor"
                            width="100%"
                            borderRadius="xl"
                            shadow="md"
                            mb={4}
                        />

                        {/* H3 */}
                        <MKTypography variant="h3" mb={3} color="dark">
                            Curățarea prin metoda injecție-extracție
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Procesul bazat pe injecție și extracție este considerat cea mai
                            eficientă soluție pentru igienizarea în profunzime, unde mocheta este
                            spălată până la baza suportului. Această metodă presupune pulverizarea
                            sub presiune a unei soluții profesionale de curățare, urmată imediat de
                            aspirarea puternică a lichidului împreună cu murdăria dizolvată.
                            Vacuumul creat elimină acarienii, poluanții și praful fin blocat între
                            fibre.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={4}>
                            Performanța acestui sistem este susținută de date tehnice privind
                            sănătatea mediului interior. Conform National Institute of Environmental
                            Health Sciences, mochetele pot acumula între 100.000 și 10 milioane de
                            microorganisme pe metru pătrat. Tehnologia noastră reduce această
                            prezență biologică cu până la 99%, oferind o siguranță reală pentru
                            utilizatori. Pentru a menține igiena generală a clădirii, această etapă
                            poate fi corelată cu serviciile noastre de{" "}
                            <a
                                href="https://www.doral-cleaning.ro/curatare-pardoseli"
                                style={{ color: "#1a73e8", textDecoration: "underline" }}
                            >
                                curățare a pardoselilor
                            </a>
                            , asigurând o abordare completă a suprafețelor de trafic. Puterea mare
                            de vacuum a utilajelor noastre extrage majoritatea umidității, reducând
                            timpul de așteptare și prevenind formarea mirosurilor neplăcute.
                        </MKTypography>

                        {/* H2 */}
                        <MKTypography variant="h2" mb={3} color="dark">
                            Metode de curățare uscată și igienizare termică
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Pentru țesăturile delicate care nu suportă apa, aplicăm metode uscate
                            sub formă de spray, praf, granule sau șamponare uscată.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Această abordare păstrează integritatea, culoarea și textura
                            materialului, eliminând riscul de intrare la apă.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={4}>
                            În completare, oferim igienizarea cu aparate cu abur și extracție, care
                            asigură o decontaminare termică superioară. Aceste tehnici sunt parte
                            integrantă din soluțiile noastre de{" "}
                            <a
                                href="https://www.doral-cleaning.ro/intretinere-si-tratamente-aplicate-pentru-pardoseli"
                                style={{ color: "#1a73e8", textDecoration: "underline" }}
                            >
                                tratare a pardoselilor
                            </a>
                            , fiind adaptate special pentru materialele sensibile.
                        </MKTypography>

                        {/* H2 */}
                        <MKTypography variant="h2" mb={3} color="dark">
                            Diferența dintre perierea rotativă și cea circulară
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Mecanismul de acțiune al periilor este determinant pentru intensitatea
                            igienizării.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Diferența principală între perierea rotativă și circulară în spălarea
                            mochetei constă în modul în care fibra este tratată: peria rotativă
                            curăță în profunzime prin ridicarea firelor, fiind ideală pentru mochete
                            foarte murdare sau cu praf acumulat.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={4}>
                            În schimb, peria circulară, prin mișcări laterale, este mai blândă,
                            fiind excelentă pentru distribuirea detergentului și finisarea zonelor
                            sensibile fără a deteriora mocheta. Alegerea depinde de gradul de
                            murdărie, ambele metode fiind complementare într-un proces complet.
                        </MKTypography>

                        {/* H3 */}
                        <MKTypography variant="h3" mb={3} color="dark">
                            Utilizarea soluțiilor ecologice și hipoalergenice
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Folosim exclusiv soluții dedicate, biodegradabile și hipoalergenice,
                            care garantează rezultate impecabile fără a lăsa reziduuri chimice
                            nocive în urmă.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Această alegere este determinantă pentru sănătatea angajaților și a
                            membrilor familiei, prevenind iritațiile sau reacțiile alergice.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={4}>
                            Produsele noastre au un pH neutru care protejează culorile originale ale
                            țesăturii și nu atrag praful după spălare, menținând suprafața curată
                            pentru o perioadă mai lungă.
                        </MKTypography>

                        {/* H2 */}
                        <MKTypography variant="h2" mb={3} color="dark">
                            Spălăm mocheta direct la sediul firmei tale
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Oferim soluții flexibile pentru companii, realizând spălarea mochetei
                            direct la sediu, fără a perturba activitatea zilnică a angajaților.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Planificăm intervențiile în afara orelor de program sau în weekend,
                            astfel încât mocheta să fie complet uscată până la reluarea activității.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={4}>
                            Această mobilitate ne permite să gestionăm suprafețe mari într-un
                            interval scurt de timp, oferind un avantaj logistic real clienților B2B
                            care au nevoie de eficiență. Detalii despre pachetele noastre pot fi
                            consultate în secțiunea dedicată pentru{" "}
                            <a
                                href="https://www.doral-cleaning.ro/contact-curatenie"
                                style={{ color: "#1a73e8", textDecoration: "underline" }}
                            >
                                curățare mochete
                            </a>
                            .
                        </MKTypography>

                        <MKBox
                            component="img"
                            src={curatareMochete4}
                            alt="Servicii profesionale de spălat mocheta la sediul firmei - curatare mochete"
                            width="100%"
                            borderRadius="xl"
                            shadow="md"
                            mb={4}
                        />

                        {/* H2 */}
                        <MKTypography variant="h2" mb={3} color="dark">
                            Eficiență și curățenie la standarde înalte cu Doral Cleaning
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={4}>
                            Suntem printre cei mai apreciați furnizori de servicii profesionale de
                            curățenie în întreținerea și curățarea suprafețelor textile. Dacă aveți
                            nevoie de serviciile unor profesioniști care practică tarife corecte,
                            echipa Doral Cleaning utilizează tehnologii de vârf pentru a reda
                            aspectul impecabil al spațiului dumneavoastră. Ne asumăm rigoarea
                            tehnică a fiecărui proiect pentru a asigura o curățare eficientă și
                            durabilă.
                        </MKTypography>

                        {/* H2 */}
                        <MKTypography variant="h2" mb={3} color="dark">
                            Checklist: Cum să pregătești locația înainte de sosirea echipei
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Pentru a facilita un proces de lucru rapid și pentru a proteja obiectele
                            de valoare, vă recomandăm parcurgerea următorilor pași înainte de
                            sosirea echipei noastre:
                        </MKTypography>

                        <MKBox
                            component="img"
                            src={curatareMocheteChecklist}
                            alt="checklist curatare mochete"
                            width="100%"
                            borderRadius="xl"
                            shadow="md"
                            mb={4}
                        />

                        <MKBox component="ul" pl={4} mb={4}>
                            <MKTypography component="li" variant="body1" color="text" mb={1}>
                                Identificați zonele cu pete dificile (cafea, vin, tuș, etc) și
                                comunicați personalului nostru natura acestora pentru aplicarea
                                tratamentului corect.
                            </MKTypography>
                            <MKTypography component="li" variant="body1" color="text" mb={1}>
                                Degajați obiectele mici, cablurile și piesele de mobilier ușoare
                                pentru a permite accesul liber al utilajelor mecanizate.
                            </MKTypography>
                            <MKTypography component="li" variant="body1" color="text" mb={1}>
                                Asigurați accesul la o sursă de apă și la energie electrică în
                                proximitatea zonelor ce necesită igienizare.
                            </MKTypography>
                            <MKTypography component="li" variant="body1" color="text" mb={1}>
                                Verificați dacă există zone unde mocheta este dezlipită sau
                                degradată și raportați aceste defecte echipei de intervenție.
                            </MKTypography>
                            <MKTypography component="li" variant="body1" color="text" mb={1}>
                                Pregătiți sistemul de ventilație sau climatizare pentru a fi pornit
                                imediat după finalizarea lucrării, accelerând astfel procesul de
                                uscare.
                            </MKTypography>
                        </MKBox>

                        {/* H2 */}
                        <MKTypography variant="h2" mb={3} color="dark">
                            Sfaturi practice pentru protejarea textilelor
                        </MKTypography>

                        <MKTypography variant="body1" color="text" mb={2}>
                            Pentru a menține curățenia un timp cât mai îndelungat, vă oferim câteva
                            recomandări tehnice:
                        </MKTypography>

                        <MKBox component="ul" pl={4} mb={4}>
                            <MKTypography component="li" variant="body1" color="text" mb={1}>
                                <strong>Protejați mocheta de murdaria din exterior</strong>: Plasați
                                la intrare traverse textile pentru preluarea murdăriei grosiere.
                                Alegeți produse de calitate sau apelați la servicii de închiriere a
                                acestora pentru a reduce uzura.
                            </MKTypography>
                            <MKTypography component="li" variant="body1" color="text" mb={1}>
                                <strong>Informați prestatorul</strong>: Oferiți echipei detalii
                                despre materialele care necesită intervenție. Este foarte important
                                ca acestea să fie analizate în prealabil în funcție de tipul de
                                țesătură, compoziția fibrei și temperatura optimă de lucru.
                            </MKTypography>
                        </MKBox>

                        {/* H3 - FAQ */}
                        <MKTypography variant="h3" mb={3} color="dark">
                            Întrebări frecvente
                        </MKTypography>

                        <MKBox component="ul" pl={4} mb={4}>
                            <MKTypography component="li" variant="body1" color="text" mb={2}>
                                <strong>
                                    Cum aleg o firmă bună care să se ocupe de spălarea mochetei?
                                </strong>
                                <br />O firmă de încredere se recunoaște prin utilizarea
                                echipamentelor industriale de marcă, portofoliul de clienți
                                verificabil și transparența totală privind soluțiile folosite. Un
                                furnizor serios va analiza tipul de fibră înainte de a propune o
                                metodă de lucru, fie că este vorba despre periere rotativă sau
                                curățare uscată.
                            </MKTypography>
                            <MKTypography component="li" variant="body1" color="text" mb={2}>
                                <strong>
                                    Care sunt prețurile orientative pentru curățarea profesională?
                                </strong>
                                <br />
                                Costurile pentru un curățat de mochete la un preț corect se situează
                                de obicei între șapte și cincisprezece lei pe metru pătrat. Prețul
                                unitar scade progresiv pe măsură ce suprafața totală de curățat este
                                mai mare, incluzând evaluarea tehnică și utilizarea soluțiilor
                                dedicate pentru fiecare tip de pată.
                            </MKTypography>
                            <MKTypography component="li" variant="body1" color="text" mb={2}>
                                <strong>Cum se face igienizarea mochetei pentru birouri?</strong>
                                <br />
                                Procesul presupune o aspirare industrială inițială forțată, urmată
                                de tratarea petelor prin tapotare (fără frecare) și aplicarea
                                metodei de injecție-extracție. Totul este programat în afara orelor
                                de program pentru a asigura o uscare rapidă și zero perturbări în
                                activitatea firmei.
                            </MKTypography>
                            <MKTypography component="li" variant="body1" color="text" mb={2}>
                                <strong>
                                    În cât timp se usucă suprafața după ce a fost spălată?
                                </strong>
                                <br />
                                În mod obișnuit, uscarea completă se realizează în patru sau șase
                                ore, în funcție de ventilația spațiului și de tipul materialului
                                textil. Utilajele noastre de extracție elimină peste 80% din
                                umiditate, permițând utilizarea suprafeței în aceeași zi.
                            </MKTypography>
                            <MKTypography component="li" variant="body1" color="text" mb={2}>
                                <strong>
                                    Metoda de lucru este sigură pentru angajati sau animale?
                                </strong>
                                <br />
                                Da, utilizăm doar detergenți biodegradabili și soluții
                                hipoalergenice. Acestea nu prezintă niciun risc pentru sănătate și
                                nu lasă reziduuri chimice, fiind opțiunea optimă pentru procesul de
                                igienizare a mochetelor la domiciliu.
                            </MKTypography>
                            <MKTypography component="li" variant="body1" color="text" mb={2}>
                                <strong>Tehnologiile folosite scot și mirosurile neplăcute?</strong>
                                <br />
                                Da, tehnologia noastră elimină sursa mirosurilor prin extragerea
                                bacteriilor și a murdăriei din profunzimea fibrelor. Prin curățarea
                                până la baza suportului mochetei, oferim o prospețime reală și
                                durabilă, fără a masca mizeria cu parfumuri sintetice.
                            </MKTypography>
                        </MKBox>
                    </Grid>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default ArticleContent;
